/* TONA PDP (new). Variant selection, gallery by color, add to bag through the header cart drawer, modals. */
(() => {
  const routesRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const money = (cents) => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    } catch (error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const norm = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

  // The header section owns the cart drawer. Same hand-off as the live PDP.
  const openCartDrawer = () => {
    const drawer = document.querySelector('[data-tona-cart-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) {
      const opener = document.querySelector('[data-tona-cart-open]');
      if (opener) opener.click();
    }
  };

  const updateCartCount = (count) => {
    ['[data-tona-cart-count]', '[data-cart-count]', '.Header__CartCount', '#CartCount', '.cart-count-bubble span'].forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.textContent = count;
        element.hidden = count === 0;
      });
    });
  };

  const addToCart = async (items) => {
    const response = await fetch(`${routesRoot()}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'This product could not be added.');
    const cart = await (await fetch(`${routesRoot()}cart.js`, { headers: { Accept: 'application/json' } })).json();
    updateCartCount(cart.item_count || 0);
    document.dispatchEvent(new CustomEvent('tona:cart-updated', { detail: { cart, source: 'tona-pdp' } }));
    window.requestAnimationFrame(openCartDrawer);
    return cart;
  };

  // Waist chart and height rule from the live Find My Size.
  const WAIST_CHART = [[25, '0'], [27, '2'], [29, '4'], [31, '6'], [33, '8'], [35, '10'], [38, '12'], [41, '14'], [44, '16'], [47, '18'], [50, '20'], [53, '22'], [56, '24']];
  const sizeForWaist = (waist) => {
    if (waist < 25) return '00';
    let size = '0';
    WAIST_CHART.forEach(([min, value]) => {
      if (waist >= min) size = value;
    });
    return size;
  };

  const initPdp = (root) => {
    if (root.dataset.tonaPdpReady === 'true') return;
    root.dataset.tonaPdpReady = 'true';

    const variantsNode = root.querySelector('[data-tona-pdp-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const optionInputs = (type) => [...root.querySelectorAll(`[data-tona-pdp-option="${type}"]`)];
    const inputs = { color: optionInputs('color'), length: optionInputs('length'), size: optionInputs('size') };
    const positions = {};
    Object.keys(inputs).forEach((type) => {
      positions[type] = Number((inputs[type][0] && inputs[type][0].dataset.position) || 0);
    });
    const types = Object.keys(inputs).filter((type) => positions[type]);
    const checkedValue = (type) => (inputs[type].find((input) => input.checked) || {}).value || '';
    const selection = () => ({ color: checkedValue('color'), length: checkedValue('length'), size: checkedValue('size') });
    const matches = (variant, sel) => types.every((type) => !sel[type] || variant.options[positions[type] - 1] === sel[type]);
    const isComplete = (sel) => types.every((type) => sel[type]);
    const findVariant = (sel) => (isComplete(sel) ? variants.find((variant) => matches(variant, sel)) : null);
    const anyAvailable = (sel) => variants.some((variant) => variant.available && matches(variant, sel));
    const anyExisting = (sel) => variants.some((variant) => matches(variant, sel));

    const el = (selector) => root.querySelector(selector);
    const colorName = el('[data-tona-pdp-color-name]');
    const price = el('[data-tona-pdp-price]');
    const compare = el('[data-tona-pdp-compare]');
    const status = el('[data-tona-pdp-status]');
    const statusLabel = el('[data-tona-pdp-status-label]');
    const form = el('[data-tona-pdp-form]');
    const variantInput = el('[data-tona-pdp-variant-id]');
    const addButton = el('[data-tona-pdp-add]');
    const addLabel = el('[data-tona-pdp-add-label]');
    const message = el('[data-tona-pdp-message]');
    const sizesGroup = el('.tona-pdp__sizes');
    const tiles = [...root.querySelectorAll('.tona-pdp__media')];
    const badge = el('[data-tona-pdp-badge]');
    const caption = el('[data-tona-pdp-caption]');
    const captionsNode = el('[data-tona-pdp-captions]');
    const captions = captionsNode ? JSON.parse(captionsNode.textContent) : null;
    // A Model caption block for the color wins, otherwise the default caption if it covers this color.
    const captionFor = (key) => {
      if (!captions) return null;
      const own = captions.colors.find((item) => norm(item.color) === key);
      if (own) return own.hide || !own.title ? null : own;
      const base = captions.default;
      const only = norm(base.color);
      return base.title && (!only || only === key) ? base : null;
    };
    const parking = el('.tona-pdp__parking');
    const gallery = el('[data-tona-pdp-gallery]');
    const thumbStrip = el('[data-tona-pdp-thumbs]');
    const thumbs = [...root.querySelectorAll('[data-tona-pdp-thumb]')];
    const sticky = el('[data-tona-pdp-sticky]');
    const stickyAdd = el('[data-tona-pdp-sticky-add]');
    // The Sticky bar button setting, shown until a size is picked.
    const stickySelectLabel = stickyAdd ? stickyAdd.firstElementChild.textContent : '';

    // Mobile thumbnails follow the swipe gallery. The slide nearest the gallery's left edge is the active one.
    const thumbFor = (tile) => thumbs.find((thumb) => thumb.dataset.tonaPdpThumb === tile.dataset.mediaId);
    const markThumb = () => {
      if (!gallery || !thumbs.length) return;
      const left = gallery.getBoundingClientRect().left;
      let nearest = null;
      tiles.forEach((tile) => {
        if (tile.hidden) return;
        const distance = Math.abs(tile.getBoundingClientRect().left - left);
        if (!nearest || distance < nearest.distance) nearest = { tile, distance };
      });
      const active = nearest && thumbFor(nearest.tile);
      thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === active));
      if (active && thumbStrip) {
        const strip = thumbStrip.getBoundingClientRect();
        const box = active.getBoundingClientRect();
        if (box.left < strip.left || box.right > strip.right) {
          thumbStrip.scrollBy({ left: box.left - strip.left - 16, behavior: 'smooth' });
        }
      }
    };
    let thumbTimer = null;
    if (gallery) {
      gallery.addEventListener('scroll', () => {
        clearTimeout(thumbTimer);
        thumbTimer = setTimeout(markThumb, 60);
      }, { passive: true });
    }
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      const tile = tiles.find((item) => item.dataset.mediaId === thumb.dataset.tonaPdpThumb);
      if (!tile || !gallery) return;
      gallery.scrollBy({ left: tile.getBoundingClientRect().left - gallery.getBoundingClientRect().left, behavior: 'smooth' });
    }));

    const showMessage = (text) => {
      if (!message) return;
      message.textContent = text;
      message.hidden = !text;
    };

    const updateGallery = (color) => {
      if (!tiles.length) return;
      const key = norm(color);
      let shown = tiles.filter((tile) => {
        const alt = norm(tile.dataset.mediaAlt);
        return (key && alt.includes(key)) || /\ball colou?rs?\b/.test(alt);
      });
      if (!shown.length) shown = tiles;
      tiles.forEach((tile) => {
        tile.hidden = !shown.includes(tile);
      });
      thumbs.forEach((thumb) => {
        const tile = tiles.find((item) => item.dataset.mediaId === thumb.dataset.tonaPdpThumb);
        thumb.hidden = !tile || tile.hidden;
      });
      if (gallery) gallery.scrollLeft = 0;
      markThumb();
      if (badge) (shown[0] || parking).append(badge);
      if (caption) {
        const data = captionFor(key);
        const target = data ? shown[Number(data.position || 2) - 1] : null;
        if (data) {
          caption.querySelector('.tona-pdp__caption-title').textContent = data.title;
          const details = caption.querySelector('.tona-pdp__caption-details');
          details.textContent = data.details || '';
          details.hidden = !data.details;
        }
        (target || parking).append(caption);
      }
      root.querySelectorAll('.tona-pdp__media video').forEach((video) => {
        if (video.closest('[hidden]')) {
          video.pause();
        } else if (video.paused && video.autoplay) {
          video.play().catch(() => {});
        }
      });
    };

    // Keep the length valid for the chosen color, preferring one that still has stock.
    const ensureLength = () => {
      if (!positions.length) return;
      const sel = selection();
      if (sel.length && anyAvailable({ color: sel.color, length: sel.length })) return;
      const next = inputs.length.find((input) => anyAvailable({ color: sel.color, length: input.value }))
        || inputs.length.find((input) => anyExisting({ color: sel.color, length: input.value }));
      if (next) next.checked = true;
    };

    const updateAvailability = () => {
      const sel = selection();
      inputs.size.forEach((input) => {
        const available = anyAvailable({ ...sel, size: input.value });
        input.disabled = !available;
        if (!available && input.checked) input.checked = false;
        input.closest('.tona-pdp__chip').classList.toggle('is-unavailable', !available);
      });
      inputs.length.forEach((input) => {
        const available = anyAvailable({ color: sel.color, length: input.value });
        input.closest('.tona-pdp__chip').classList.toggle('is-unavailable', !available);
      });
      inputs.color.forEach((input) => {
        input.closest('.tona-pdp__swatch').classList.toggle('is-sold-out', !anyAvailable({ color: input.value }));
      });
    };

    const markSelected = () => {
      [...inputs.color, ...inputs.length, ...inputs.size].forEach((input) => {
        const label = input.closest('label');
        if (label) label.classList.toggle('is-selected', input.checked);
      });
    };

    // Set further down when the size guide exists. Every buy box change runs it, so the guide mirrors the buy box.
    let syncGuide = () => {};
    // Same for the Find My Size popup, which shows the buy box color and whether the pick can be added.
    let syncFit = () => {};

    const update = ({ colorChanged = false } = {}) => {
      if (colorChanged) ensureLength();
      updateAvailability();
      markSelected();
      const sel = selection();
      if (colorName) colorName.textContent = sel.color;

      const variant = findVariant(sel);
      const fallback = variants.find((item) => item.available && matches(item, { color: sel.color, length: sel.length }))
        || variants.find((item) => matches(item, { color: sel.color }))
        || variants[0];
      const shown = variant || fallback;
      if (!shown) return;

      if (price) price.textContent = money(shown.price);
      if (compare) {
        const onSale = shown.compare_at_price > shown.price;
        compare.hidden = !onSale;
        compare.textContent = onSale ? money(shown.compare_at_price) : '';
      }

      const inStock = variant ? variant.available : anyAvailable({ color: sel.color, length: sel.length });
      if (status && statusLabel) {
        status.classList.toggle('is-sold-out', !inStock);
        statusLabel.textContent = inStock ? status.dataset.inStock : status.dataset.soldOut;
      }

      if (variantInput) variantInput.value = shown.id;
      if (addButton && addLabel) {
        const soldOut = !anyAvailable({ color: sel.color, length: sel.length });
        addButton.disabled = soldOut;
        addLabel.textContent = soldOut ? addButton.dataset.soldOut : addButton.dataset.label;
      }
      // The sticky bar shows the color only, no length, size or price (Juan, 1 Oct). Its button reads Select Size until
      // a size is picked, then takes the buy box label, Add to bag or Sold out (Juan, 1 Oct).
      if (sticky) {
        el('[data-tona-pdp-sticky-options]').textContent = sel.color;
        const sizePicked = !positions.size || Boolean(sel.size);
        if (stickyAdd && addLabel) stickyAdd.firstElementChild.textContent = sizePicked ? addLabel.textContent : stickySelectLabel;
        if (stickyAdd && addButton) stickyAdd.disabled = sizePicked && addButton.disabled;
      }
      if (sel.size) {
        showMessage('');
        if (sizesGroup) sizesGroup.classList.remove('is-flagged');
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', shown.id);
      window.history.replaceState(window.history.state, '', url.toString());

      if (colorChanged) updateGallery(sel.color);
      // The sticky bar shows the first photo of the chosen color, taken from the matching thumbnail.
      const stickyImg = sticky && el('.tona-pdp__sticky-img');
      const firstThumb = thumbs.find((thumb) => !thumb.hidden);
      if (stickyImg && firstThumb) stickyImg.src = firstThumb.querySelector('img').src;
      syncGuide();
      syncFit();
    };

    inputs.color.forEach((input) => input.addEventListener('change', () => update({ colorChanged: true })));
    inputs.length.forEach((input) => input.addEventListener('change', () => update()));
    inputs.size.forEach((input) => input.addEventListener('change', () => update()));

    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const sel = selection();
        if (positions.size && !sel.size) {
          showMessage(message ? message.dataset.chooseSize : '');
          if (sizesGroup) sizesGroup.classList.add('is-flagged');
          // Centre the Add to Bag button, so the flagged sizes above it and the warning under it are both in view,
          // also when the tap came from the sticky bar far down the page.
          addButton.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        const variant = findVariant(sel);
        if (!variant || !variant.available) return;
        addButton.classList.add('is-loading');
        addButton.disabled = true;
        if (stickyAdd) stickyAdd.disabled = true;
        try {
          await addToCart([{ id: variant.id, quantity: 1 }]);
          showMessage('');
        } catch (error) {
          showMessage(error.message);
        } finally {
          addButton.classList.remove('is-loading');
          addButton.disabled = false;
          if (stickyAdd) stickyAdd.disabled = false;
        }
      });
    }

    // Sticky bar, desktop and mobile. It shows once the buy box button has scrolled up out of view, and its button
    // clicks that one, so a missing size scrolls back to the size picker exactly like the main button.
    // It also steps aside once the footer shows, so it never sits on top of it.
    if (sticky && addButton && 'IntersectionObserver' in window) {
      const footer = document.getElementById('shopify-section-tona-footer')
        || document.querySelector('.shopify-section-group-footer-group');
      let pastButton = false;
      let atFooter = false;
      const toggleSticky = () => {
        const show = pastButton && !atFooter;
        sticky.classList.toggle('is-visible', show);
        sticky.inert = !show;
      };
      new IntersectionObserver(([entry]) => {
        pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        toggleSticky();
      }).observe(addButton);
      if (footer) {
        new IntersectionObserver(([entry]) => {
          atFooter = entry.isIntersecting;
          toggleSticky();
        }).observe(footer);
      }
      // No size yet, it takes the shopper to the size picker. With a size, it adds through the buy box form.
      stickyAdd.addEventListener('click', () => {
        if (positions.size && !selection().size) {
          (sizesGroup || addButton).scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        addButton.click();
      });
    }

    root.querySelectorAll('[data-tona-pdp-look-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          await addToCart([{ id: Number(button.dataset.tonaPdpLookAdd), quantity: 1 }]);
        } catch (error) {
          showMessage(error.message);
        } finally {
          button.disabled = false;
        }
      });
    });

    // Modals use native <dialog>, so Esc and focus handling come from the browser.
    const modals = {};
    root.querySelectorAll('[data-tona-pdp-modal]').forEach((modal) => {
      modals[modal.dataset.tonaPdpModal] = modal;
      modal.addEventListener('click', (event) => {
        if (event.target === modal) modal.close();
      });
      modal.querySelectorAll('[data-tona-pdp-close]').forEach((button) => button.addEventListener('click', () => modal.close()));
    });
    const openModal = (name) => {
      const modal = modals[name];
      if (!modal || modal.open || typeof modal.showModal !== 'function') return;
      // One modal at a time, so Find My Size opened from the size guide takes its place.
      Object.values(modals).forEach((other) => other.open && other.close());
      modal.showModal();
    };
    root.querySelectorAll('[data-tona-pdp-open]').forEach((button) => {
      button.addEventListener('click', () => openModal(button.dataset.tonaPdpOpen));
    });

    // Size guide (Figma 58720:8586 and its behaviour notes). The column of the size picked in the buy box is
    // highlighted, a column lights up under the mouse or after a tap, size and length pills select that option in
    // the buy box and leave the popup open, and the unit switch rewrites every measurement.
    const guide = modals['size-chart'];
    if (guide) {
      const table = guide.querySelector('[data-tona-sg-table]');
      const pills = [...guide.querySelectorAll('[data-tona-sg-size]')];
      const lengthPills = [...guide.querySelectorAll('[data-tona-sg-length]')];
      const sizeInput = (value) => inputs.size.find((input) => input.value === value);
      const lengthInput = (value) => inputs.length.find((input) => parseFloat(input.value) === parseFloat(value));
      // Cell 0 of every row is its label, so the pill at index i heads column i + 1.
      const mark = (className, column) => {
        if (!table) return;
        [...table.rows].forEach((row) => [...row.cells].forEach((cell, i) => cell.classList.toggle(className, i === column)));
      };

      syncGuide = () => {
        const sel = selection();
        mark('is-selected', pills.findIndex((pill) => pill.dataset.tonaSgSize === sel.size) + 1 || -1);
        pills.forEach((pill) => {
          const input = sizeInput(pill.dataset.tonaSgSize);
          const unavailable = !input || input.disabled;
          pill.classList.toggle('is-unavailable', unavailable);
          pill.setAttribute('aria-disabled', String(unavailable));
          pill.setAttribute('aria-pressed', String(Boolean(input && input.checked)));
        });
        lengthPills.forEach((pill) => {
          const input = lengthInput(pill.dataset.tonaSgLength);
          const on = Boolean(input && input.checked);
          pill.classList.toggle('is-selected', on);
          pill.setAttribute('aria-pressed', String(on));
        });
      };

      const choose = (input) => {
        if (!input || input.disabled) return;
        input.checked = true;
        input.dispatchEvent(new Event('change'));
      };

      const setUnit = (unit) => {
        guide.querySelectorAll('[data-tona-sg-unit]').forEach((button) => {
          const on = button.dataset.tonaSgUnit === unit;
          button.classList.toggle('is-active', on);
          button.setAttribute('aria-pressed', String(on));
        });
        guide.querySelectorAll('[data-in]').forEach((cell) => {
          const inches = parseFloat(cell.dataset.in);
          if (Number.isNaN(inches)) return;
          cell.textContent = `${cell.dataset.prefix}${unit === 'cm' ? Math.round(inches * 2.54) : `${cell.dataset.in}"`}`;
        });
      };

      guide.addEventListener('click', (event) => {
        const pill = event.target.closest('[data-tona-sg-size]');
        if (pill) choose(sizeInput(pill.dataset.tonaSgSize));
        const length = event.target.closest('[data-tona-sg-length]');
        if (length) choose(lengthInput(length.dataset.tonaSgLength));
        const unit = event.target.closest('[data-tona-sg-unit]');
        if (unit) setUnit(unit.dataset.tonaSgUnit);
      });

      if (table) {
        table.addEventListener('pointerover', (event) => {
          const cell = event.target.closest('th, td');
          if (cell && cell.cellIndex > 0) mark('is-hover', cell.cellIndex);
        });
        // The mouse clears the highlight on its way out. A tap keeps it until the next tap.
        table.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') mark('is-hover', -1);
        });
      }
      guide.addEventListener('close', () => mark('is-hover', -1));
    }

    const fit = modals['fit-finder'];
    if (fit) {
      const waist = fit.querySelector('[data-tona-pdp-fit-waist]');
      const height = fit.querySelector('[data-tona-pdp-fit-height]');
      const result = fit.querySelector('[data-tona-pdp-fit-result]');
      const apply = fit.querySelector('[data-tona-pdp-fit-apply]');
      const fitAdd = fit.querySelector('[data-tona-pdp-fit-add]');
      const fitAddLabel = fitAdd && fitAdd.firstElementChild;
      const fitMessage = fit.querySelector('[data-tona-pdp-fit-message]');
      const fitColorsWrap = fit.querySelector('[data-tona-pdp-fit-colors-wrap]');
      const fitColors = fit.querySelector('[data-tona-pdp-fit-colors]');
      const fitColorLabel = fit.querySelector('[data-tona-pdp-fit-color-label]');
      const fitColorName = fit.querySelector('[data-tona-pdp-fit-color-name]');
      const shortMax = Number(fit.dataset.shortMax || 65);
      const lengthValues = inputs.length.map((input) => input.value).sort((a, b) => parseFloat(a) - parseFloat(b));
      const optionLabel = (type) => {
        const group = inputs[type][0] && inputs[type][0].closest('[role="radiogroup"]');
        return group ? group.getAttribute('aria-label') : '';
      };
      let recommendation = null;

      // Unhidden first and filled a frame later, so screen readers announce it.
      const showFitMessage = (text) => {
        if (!fitMessage) return;
        fitMessage.hidden = !text;
        fitMessage.textContent = '';
        if (text) window.requestAnimationFrame(() => { fitMessage.textContent = text; });
      };
      fit.addEventListener('close', () => showFitMessage(''));
      if (fitAdd) fitAdd.hidden = !addButton;
      // The variant the popup would add, the buy box color with the recommended length and size.
      const fitVariant = () => recommendation
        && findVariant({ color: selection().color, length: recommendation.length, size: recommendation.size });

      // Puts the recommendation in the buy box right away, so the page matches the popup without a click.
      const applyRecommendation = () => {
        if (!recommendation) return;
        const lengthInput = inputs.length.find((input) => input.value === recommendation.length);
        if (lengthInput) lengthInput.checked = true;
        update();
        const sizeInput = inputs.size.find((input) => input.value === recommendation.size);
        if (sizeInput && !sizeInput.disabled) {
          sizeInput.checked = true;
        } else {
          // Sold out in this color, so the buy box shouldn't keep a size the finder never suggested.
          inputs.size.forEach((input) => { input.checked = false; });
        }
        update();
      };

      // Color swatches inside the popup (Juan, 30 Sep), copied from the buy box. Picking one sets the buy box color,
      // so the gallery, the buy box and the popup always agree.
      const fitSwatches = fitColors && inputs.color.length > 1 ? inputs.color.map((input) => {
        const label = document.createElement('label');
        label.className = 'tona-pdp__swatch';
        label.setAttribute('style', input.closest('.tona-pdp__swatch').getAttribute('style') || '');
        label.title = input.value;
        const radio = document.createElement('input');
        radio.className = 'tona-pdp__sr';
        radio.type = 'radio';
        radio.name = `${input.name}-fit`;
        radio.value = input.value;
        const dot = document.createElement('span');
        dot.className = 'tona-pdp__swatch-dot';
        dot.setAttribute('aria-hidden', 'true');
        const name = document.createElement('span');
        name.className = 'tona-pdp__sr';
        name.textContent = input.value;
        label.append(radio, dot, name);
        radio.addEventListener('change', () => {
          showFitMessage('');
          input.checked = true;
          update({ colorChanged: true });
          applyRecommendation();
        });
        fitColors.append(label);
        return radio;
      }) : [];
      if (fitColorsWrap) fitColorsWrap.hidden = !fitSwatches.length;
      if (fitColors) fitColors.setAttribute('aria-label', optionLabel('color'));
      if (fitColorLabel) fitColorLabel.textContent = optionLabel('color');

      syncFit = () => {
        const color = selection().color;
        fitSwatches.forEach((radio) => {
          radio.checked = radio.value === color;
          radio.parentElement.classList.toggle('is-selected', radio.checked);
          const pick = recommendation
            ? { color: radio.value, length: recommendation.length, size: recommendation.size }
            : { color: radio.value };
          const soldOut = !anyAvailable(pick);
          radio.parentElement.classList.toggle('is-sold-out', soldOut);
          radio.parentElement.lastElementChild.textContent = soldOut && addButton
            ? `${radio.value}, ${addButton.dataset.soldOut}`
            : radio.value;
        });
        if (fitColorName) fitColorName.textContent = color;
        if (!fitAdd || !addButton) return;
        const variant = fitVariant();
        const available = Boolean(variant && variant.available);
        fitAdd.disabled = !available;
        if (fitAddLabel) {
          fitAddLabel.textContent = !recommendation || available ? addButton.dataset.label : addButton.dataset.soldOut;
        }
      };

      const recompute = () => {
        const waistValue = Number(waist.value);
        const heightValue = Number(height.value);
        showFitMessage('');
        if (!waistValue || !heightValue) {
          recommendation = null;
          result.textContent = result.dataset.empty;
          apply.disabled = true;
          syncFit();
          return;
        }
        recommendation = {
          size: sizeForWaist(waistValue),
          length: lengthValues.length ? (heightValue <= shortMax ? lengthValues[0] : lengthValues[lengthValues.length - 1]) : ''
        };
        const parts = [`${optionLabel('size')} ${recommendation.size}`];
        if (recommendation.length) parts.push(`${optionLabel('length')} ${recommendation.length}"`);
        result.textContent = parts.join(' · ');
        apply.disabled = false;
        applyRecommendation();
        syncFit();
      };
      waist.addEventListener('change', recompute);
      height.addEventListener('change', recompute);

      // Select Size, the small link under Add to bag, keeps the old behaviour for shoppers who want to stay on the page.
      apply.addEventListener('click', () => {
        if (!recommendation) return;
        applyRecommendation();
        fit.close();
        if (sizesGroup) sizesGroup.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });

      if (fitAdd) {
        fitAdd.addEventListener('click', async () => {
          const variant = fitVariant();
          if (!variant || !variant.available || fitAdd.classList.contains('is-loading')) return;
          // The loading class guards double taps. Not disabled, so keyboard focus stays on the button.
          fitAdd.classList.add('is-loading');
          fitAdd.setAttribute('aria-busy', 'true');
          showFitMessage('');
          try {
            await addToCart([{ id: variant.id, quantity: 1 }]);
            // Closed before the cart drawer opens on the next frame, so the drawer isn't stuck under the popup.
            fit.close();
          } catch (error) {
            // Closed while adding, so the error goes to the buy box where it can be seen.
            if (fit.open) showFitMessage(error.message);
            else showMessage(error.message);
          } finally {
            fitAdd.classList.remove('is-loading');
            fitAdd.removeAttribute('aria-busy');
            syncFit();
          }
        });
      }
      syncFit();

      if (new URLSearchParams(window.location.search).get('size') === 'true') openModal('fit-finder');
    }

    // A buy box taller than the screen scrolls until its bottom shows, then sticks. A shorter one sticks 20px under
    // the sticky site header.
    const buybox = el('.tona-pdp__buybox');
    if (buybox && root.classList.contains('tona-pdp--sticky')) {
      const header = document.getElementById('shopify-section-tona-header');
      const setStickyTop = () => {
        const top = Math.min((header ? header.offsetHeight : 0) + 20, window.innerHeight - buybox.offsetHeight - 20);
        root.style.setProperty('--tona-pdp-sticky-top', `${top}px`);
      };
      setStickyTop();
      window.addEventListener('resize', setStickyTop);
      if ('ResizeObserver' in window) new ResizeObserver(setStickyTop).observe(buybox);
    }

    update({ colorChanged: true });
  };

  const boot = () => document.querySelectorAll('[data-tona-pdp]').forEach(initPdp);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // ponytail: popups close when the editor re-renders the section. Reopening them on every keystroke could pull focus
  // out of the sidebar field, so the schema info tells the merchant to open the popup in the preview instead.
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-tona-pdp]');
    if (root) initPdp(root);
  });

  // Theme editor: picking an accordion block in the sidebar opens it in the preview, and picking a block that lives in
  // a modal (size guide rows, lengths and steps) opens that modal until another block is picked.
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target.matches('details.tona-pdp__accordion')) event.target.open = true;
    const modal = event.target.closest('dialog[data-tona-pdp-modal]');
    if (modal && !modal.open) modal.showModal();
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const modal = event.target.closest('dialog[data-tona-pdp-modal]');
    if (modal && modal.open) modal.close();
    // Back to the Open by default setting, which the select above overrode.
    if (event.target.matches('details.tona-pdp__accordion')) event.target.open = event.target.dataset.open === 'true';
  });

  // Buttons in other sections (the proof section's "Find your perfect fit") open the PDP's modals too.
  // Without that modal on the page, the button scrolls back to the buy box instead of doing nothing.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tona-pdp-open]');
    if (!button || button.closest('[data-tona-pdp]')) return;
    const pdp = document.querySelector('[data-tona-pdp]');
    const modal = pdp && pdp.querySelector(`[data-tona-pdp-modal="${button.dataset.tonaPdpOpen}"]`);
    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else if (pdp) {
      pdp.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // ponytail: the Buy 2 Get 1 picker still lives on the old leggings template, so the cart drawer's "Choose second
  // pair" and "Choose FREE pair" open it there, where ?tona_offer shows the picker. Remove once the picker is ported.
  const offerModes = ['upgrade', 'free-only'];
  const offerUrl = (mode) => `${window.location.pathname}?view=liftfit-leggings&tona_offer=${mode}`;
  document.addEventListener('tona:open-bundle-offer', (event) => {
    const detail = event.detail || {};
    if (!document.querySelector('[data-tona-pdp]') || !offerModes.includes(detail.mode)) return;
    detail.handled = true;
    // Same delay as the header, so its drawer finishes closing first.
    window.setTimeout(() => window.location.assign(offerUrl(detail.mode)), 310);
  });
  // "Choose FREE pair" clicked on another page lands here with ?tona_offer.
  const landedOffer = new URLSearchParams(window.location.search).get('tona_offer');
  if (offerModes.includes(landedOffer) && document.querySelector('[data-tona-pdp]')) {
    window.location.replace(offerUrl(landedOffer));
  }
})();
